<div class="container-fluid bg-beige">
    <div class="row">
        <div class="col-lg-6 left-contact-content">
            <div class="row pl-5 mb-pr">
                <div class="col-sm-6 blue-box">
                    <h1>Info</h1>
                    <br>
                    <p class="text-bold">Old Faithful Plumbing</p>
                    <br>
                    <p>Edmonton, AB</p>
                    <br>
                    <p>Canada</p>
                    <br>
                    <p class="pt-5">Phone: 587-568-1541</p>
                    <br>
                    <p class="pb-5 text-wordbreak">Email: oldfaithfulplumbing@gmail.com</p>
                </div>
                <div class="col-sm-6 mb-pt">
                    <div class="container">
                        <p class="p-large">HOURS OF OPERATION</p>
                        <br>
                        <p>Monday - Friday</p>
                        <br>
                        <p class="pb-5">7:00 AM - 5:00 PM</p>
                        <div class="content-break-bottom"></div>
                        <p class="p-large">SERVICING AREA</p>
                        <br>
                        <p>Edmonton, AB</p>
                        <br>
                        <p class="pb-5">&amp; surrounding area</p>
                        <div class="content-break-bottom"></div>
                        <p class="p-large">ELSEWHERE</p>
                        <div class="contact-icons pt-3">
                            <a href="https://www.facebook.com/profile.php?id=61567152825239" class="rounded-circle sm-circle social-media-icons">
                                <picture>
                                    <source srcset="../assets/site-theme/FacebookIconBeige.svg">
                                    <img class="social-media-icon" src="../assets/site-theme/FacebookIconBeige.svg" alt="Facebook Icon">
                                </picture>
                            </a>
                            <!-- they do not have twitter
                            <a href="https://x.com/oldfaithfulplumbing" class="rounded-circle sm-circle social-media-icons">
                                <picture>
                                    <source srcset="../assets/site-theme/TwitterXIconBeige.svg">
                                    <img class="social-media-icon" src="../assets/site-theme/TwitterXIconBeige.svg" alt="Twitter X Icon">
                                </picture>
                            </a>
                            -->
                            <a href="https://www.instagram.com/oldfaithfulplumbing/" class="rounded-circle sm-circle social-media-icons">
                                <picture>
                                    <source srcset="../assets/site-theme/InstagramIconBeige.svg">
                                    <img class="social-media-icon" src="../assets/site-theme/InstagramIconBeige.svg" alt="Instagram Icon">
                                </picture>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row pt-5">
                <div class="col-12">
                    <div class="container-fluid bg-beige pt-3">
                        <div class="retro-thick mb-3"></div>
                        <div class="retro-thin"></div>
                    </div>
            
                    <h1 class="text-center pb-5">GET IN TOUCH</h1>

                    <div class="container">
                        <div class="row">
                            <div class="col-sm-6">
                                <div class="input-group">
                                    <input type="text" class="form-control" placeholder="Name*" [(ngModel)]="contactName">
                                </div>
                            </div>
                            <div class="col-sm-6 mb-pt">
                                <div class="input-group">
                                    <input type="text" class="form-control" placeholder="Company" [(ngModel)]="contactCompany">
                                </div>
                            </div>
                        </div>
                        <div class="row pt-5">
                            <div class="col-sm-6">
                                <div class="input-group">
                                    <input type="text" class="form-control" placeholder="Phone*" [(ngModel)]="contactPhone">
                                </div>
                            </div>
                            <div class="col-sm-6 mb-pt">
                                <div class="input-group">
                                    <input type="text" class="form-control" placeholder="Email*" [(ngModel)]="contactEmail">
                                </div>
                            </div>
                        </div>
                        <div class="row pt-5">
                            <div class="col-sm-6">
                                <div class="input-group">
                                    <input type="text" class="form-control" placeholder="Address*" [(ngModel)]="contactAddress">
                                </div>
                            </div>
                            <div class="col-sm-6 mb-pt">
                                <select class="form-select form-control" [(ngModel)]="contactReferral">
                                    <option>Where did you hear about us?</option>
                                    <option>Internet Search</option>
                                    <option>Referral</option>
                                    <option>Physical Advertising</option>
                                    <option>Social Media</option>
                                    <option>Other</option>
                                </select>
                            </div>
                        </div>
                        <div class="row pt-5">
                            <div class="col-sm-6">
                                <div class="input-group">
                                    <input type="text" class="form-control" placeholder="Project Name" [(ngModel)]="contactProject">
                                </div>
                            </div>
                            <div class="col-sm-6 mb-pt">
                                <div class="input-group">
                                    <input type="text" class="form-control" placeholder="Project Due Date" [(ngModel)]="contactDue">
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 pt-5 pb-5">
                                <textarea _ngcontent-serverapp-c27="" rows="3" placeholder="Additional Details" class="form-control" [(ngModel)]="contactDetails"></textarea>
                            </div>
                        </div>
                        <div class="col-sm-12 d-flex justify-content-center pb-5" *ngIf="mailSent === false">
                            <button type="button" class="btn btn-red" (click)="submitMessage()">SUBMIT</button>
                        </div>
                        <div class="col-12 d-flex justify-content-center">
                            <p>{{ submitMsg }}<br><br></p>
                        </div>
                        <div class="mb-for-footer container-fluid bg-beige pb-3">
                            <div class="retro-thin mb-3"></div>
                            <div class="retro-thick"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--RIGHT CONTENT BEGINS-->
        <div class="col-lg-6 contact-image img-split mb-display-none"></div>
    </div>
</div>